import React from "react"
import { useContent } from "@thoughtbot/superglue"

import { DeveloperDocsLayout, type DeveloperDocsPage } from "@javascript/components/developer-docs/DeveloperDocsLayout"
import { SecurityPage } from "@javascript/components/developer-docs/SecurityPage"

interface SecurityContent {
  pages: DeveloperDocsPage[]
}

export default function Security() {
  const { pages } = useContent<SecurityContent>()

  return (
    <DeveloperDocsLayout pages={pages} currentHref="/developers/security">
      <SecurityPage />
    </DeveloperDocsLayout>
  )
}
